import { call } from 'redux-saga/effects';
import { eventBus } from 'utils/eventBus';

export function* onRecordingStoppedSaga() {
  yield call(eventBus.sendMessage, 'recordingStopped');
}
